import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { CustomFieldControl, DataService, SharedModule } from '@vendure/admin-ui/core';
import { Country } from '@vendure/core';
import { gql } from 'graphql-tag';
import { Observable } from 'rxjs';

export const GET_AVAILABLE_COUNTRIES = gql`
  query GetAvailableCountries {
    countries(options: { filter: { enabled: { eq: true } } }) {
        items {
            code
            name
        }
    }
  }
`;

@Component({
  selector: 'app-country-select-filter',
  template: `
    <div class="flex items-center">
      <select class="mt-1"
        [formControl]="formControl"
        [disabled]="readonly">
        <option [ngValue]="null">Select a Country...</option>
        <option *ngFor="let country of countries$ | async" [ngValue]="country.code">
          {{ country.name }}
        </option>
      </select>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SharedModule],
  standalone: true,
})
export class CountrySelectComponent implements CustomFieldControl, OnInit {
    @Input() readonly: boolean;
    @Input() formControl: FormControl;
    @Input() config: any;

    countries$: Observable<Country[]>;
    constructor(
        private dataService: DataService
    ) {}
    ngOnInit() {
        this.countries$ = this.dataService
        .query(GET_AVAILABLE_COUNTRIES)
        .mapSingle((data: any) => data.countries.items);
    }
}